<template>
  <div class="c-light-or-dark u-text-align-center">
    <h1
      class="t-heading-5 u-margin-bottom-small"
    >
      {{ step.title }}
    </h1>
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="u-margin-bottom-medium"
      v-html="step.personalizationDescription"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div>
      <btn
        :button-size="['thin', 'small']"
        class="u-margin-bottom-small c-light-or-dark__rebel-button"
        @click="rebelBtnClick"
      >
        Rebel
      </btn>
    </div>
    <div>
      <btn
        :button-size="['thin', 'small']"
        class="u-margin-bottom-small"
        @click="empireBtnClick"
      >
        Empire
      </btn>
    </div>
    <div class="c-light-or-dark__border-divider u-margin-bottom-medium" />
    <div>
      <div v-if="rebelStockMessage">
        <p>Rebel bracelets are currently out of stock.</p>
      </div>
      <div v-if="empireStockMessage">
        <p>Empire bracelets are currently out of stock.</p>
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
import Btn from "../button/Btn";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
export default {
  name:'LightOrDark',
  components: {
    Btn
  },
  props: {
    step: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      rebelStockMessage: false,
      empireStockMessage: false,
    }
  },
  computed: {
    ...mapState('braceletBuilder', [
      'bracelets',
      'selections',
      'currentStep',
      'clasps',
      'queryStringOnce',
      'sleeves'
    ]),
    ...mapGetters('braceletBuilder',[
      'loading',
      'nextStep',
      'bandColor'
    ]),
  },
  mounted() {
    if(this.queryStringOnce &&
        Object.keys(this.$route.query).length > 0 &&
        this.currentStep.handle == "star-wars-bracelet-light-or-dark-side"){
      //Empire
      if(this.$route.query.starWarsType == 'Empire'){
        this.empireBtnClick()
      }
      //Rebellion
      if(this.$route.query.starWarsType == 'Rebellion'){
        this.rebelBtnClick()
      }
      this.setQueryStringOnce(false)
    }
  },
  methods: {
    ...mapActions('braceletBuilder', [
      'incrementStep'
    ]),
    ...mapMutations('braceletBuilder', [
      'setStarWarsType',
      'setQueryStringOnce',
      'update'
    ]),
    selectBand(color) {
      let newBand = this.bracelets.find((bracelet)=>{return bracelet.title.includes(color)})
      if (newBand) {
        let band = this.bracelets.find((bracelet) => {
          return bracelet.handle === newBand.handle
        })

        if (this.selections.size) {
          let variant = band.variants.find((variant) => {
            return variant.title === this.selections.size;
          });
          this.update({
            'bracelet': variant,
          })
        } else {
          //if no size is set, default to first available variant
          if(band){
            return this.update({
              'bracelet': band.variants[0]
            });
          }

        }
      }
    },
    selectClasp() {
      for (let clasp of this.clasps) {
        console.log(clasp.variants)
        let selectedClasp = clasp.variants.find((clasp)=>{return clasp.title.includes("Brushed") })
        if (selectedClasp) {
          return this.update({'clasp': selectedClasp});
        }
      }


    },
    selectSleeve(sleeveType) {
      console.log('sleeveType',this.sleeves)
      let selectedSleeve = this.sleeves.find((sleeve)=>{return sleeve.handle.includes(sleeveType.toLowerCase()) }).variants[0]
      if (selectedSleeve) {
        return this.update({'sleeve': selectedSleeve});
      }
    },
    rebelBtnClick() {
      this.setStarWarsType("Rebellion")
      this.selectBand("Rebellion")
      this.selectClasp("Rebellion")
      this.selectSleeve("Rebellion")
      if(this.selections.sleeve && this.selections.sleeve.availableForSale) {
        this.incrementStep();
      }
      else {
        this.$emit('ShowEmailCapture')
        this.rebelStockMessage = true
        this.empireStockMessage = false
      }

    },
    empireBtnClick() {
      this.setStarWarsType("Empire")
      this.selectBand("Empire")
      this.selectClasp("Empire")
      this.selectSleeve("Empire")
      if(this.selections.sleeve && this.selections.sleeve.availableForSale) {
        this.incrementStep();
      }
      else {
        this.$emit('ShowEmailCapture')
        this.empireStockMessage = true
        this.rebelStockMessage = false
      }
    }
  },
}
</script>
<style  scoped lang="scss">
  .c-light-or-dark {
    margin-top: rem(30px);
    margin-bottom: rem(30px);
    &__border-divider {
      height: 5px;
      width: rem(210px);
      max-width: 100%;
      margin-left:auto;
      margin-right:auto;
      @include themify($themes) {
        background-color: themed("primary");
      }
    }
    &__rebel-button {
      background-color: #EE6425;
      border: #EE6425;
      &:hover {
        background-color: #EE6425;
      }
    }
  }
</style>
